import React, { useState, useEffect } from "react";

import { Col, Row, Button, Divider, Input } from "antd";
import "./JobBudgetForm.css";
import plus from "../../../../../assets/img/plus.png";
import minus from "../../../../../assets/img/minus.png";

import history from "../../../../../routes/history";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getRecentJobListing } from "../../../../../redux/actions";

const JobBudgetForm = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const professionCode = useSelector(
    (state) => state.profileReducer.user.profile.ProfessionCode
  );
  const JobID = useSelector((state) => state.getRecentgigReducer.gigs);
  // const GigId = JobID.JobOrderId;
  const GigId = location.state.JobOrderId;
  const id = location.state.JobOrderId;
  const FromEdit = location.state.FromEdit;
  const Title = location.state.Title;
  const FacilityName = location.state.FacilityName;
  const Skills = location.state.Skills;
  const Experience = location.state.Experience;
  const Industry = location.state.Industry;
  const Description = location.state.Description;
  const WorkAuthorization = location.state.WorkAuthorization;
  const isTemplate = location.state.isTemplate;
  const Location = location.state.Location;
  const Duration = location.state.IdealContractLengthName;
  const BudgetMin = location.state.BudgetMin;
  const Role = location.state.Role;
  const JobOrderId = location.state.JobOrderId;
  const PermanentJob = location.state.PermanentJob;
  const workpolicy = location.state.workpolicy;
  const [maxLimitcheck, setMaxLimitCheck] = useState(false);

  const [rate, setRate] = useState(
    BudgetMin != null ? BudgetMin : parseInt("0")
  ); //BudgetMin != null ? BudgetMin :
  const [rateVal, setRateVal] = useState(rate != null ? rate : parseInt("0"));

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );
  const [desiredSalary, setDesiredSalary] = useState("");

  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  useEffect(() => {
    // {location.state.PermanentJob ? setDesiredSalary("Yearly"):setDesiredSalary("Hourly")}
    {
      location.state.PermanentJob
        ? setDesiredSalary("Yearly")
        : setDesiredSalary("Hourly");
    }
    // dispatch(resetCreateGig())
    // dispatch(getRecentJobListing(GigId));
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const nextHandler = () => {
    // return;
    if (!maxLimitcheck) {
      history.push({
        pathname: "/postjob/secondstep",
        state: {
          GigId: GigId
            ? GigId
            : location.state.GigId
            ? location.state.GigId
            : id,
          JobOrderId: JobOrderId
            ? JobOrderId
            : location.state.GigId
            ? location.state.GigId
            : id,
          Title: Title,
          FacilityName: FacilityName,
          Skills: Skills,
          Location: Location,
          Experience: Experience,
          Industry: Industry,
          Id: GigId ? GigId : id,
          Description: Description,
          WorkAuthorization: WorkAuthorization,
          isTemplate: isTemplate,
          FromEdit: true,
          IdealContractLengthName: Duration,
          BudgetMin: rateVal,
          BudgetType:
            desiredSalary == "Yearly"
              ? "Year"
              : desiredSalary == "Hourly"
              ? "Hour"
              : desiredSalary == "Daily"
              ? "Daily"
              : desiredSalary == "Weekly"
              ? "Week"
              : desiredSalary == "Monthly"
              ? "Month"
              : null,
          Role: Role,
          certifications: location.state.certifications,
          img: location.state.img,
          workpolicy: workpolicy,
          PermanentJob: location.state.PermanentJob,
          saveAsTemplate: location.state.saveAsTemplate,
          locobj: location.state.locobj,
          placeId: location.state.placeId,
          JobOrderType: location.state.JobOrderType,
          openPositions: location.state.openPositions,
        },
      });
    }
  };
  let count = 0;

  const backHandler = () => {
    history.push({
      pathname: "/contract-gig",
      state: {
        GigId: GigId,
        Title: Title,
        FacilityName: FacilityName,
        Skills: Skills,
        Location: location.state.locobj?.LocationWithCountry,
        Experience: Experience,
        Industry: Industry,
        Id: GigId,
        Description: Description,
        WorkAuthorization: WorkAuthorization,
        isTemplate: isTemplate,
        // FromEdit: FromEdit,
        IdealContractLengthName: Duration,
        BudgetMin: rateVal,
        Role: Role,
        FromEdit: true,
        PermanentJob: PermanentJob,
        workpolicy: workpolicy,
        WorkPolicy: workpolicy,
        saveAsTemplate: location.state.saveAsTemplate,
        locobj: location.state.locobj,
        placeId: location.state.placeId,
        NotTemplate: true,
        JobOrderTypeName:
          location.state.JobOrderTypeName ?? location.state.JobOrderType,
        openPositions: location.state.openPositions,
      },
    });
  };
  const handleInput = (e) => {
    isNaN(e.target.value)
      ? setRateVal(parseInt(0))
      : setRateVal(parseInt(e.target.value));
  };
  if (isNaN(rate)) setRate(parseInt(0));
  window.scrollTo(0, 0);

  function toFixed(num) {
    var nsign = Math.sign(num);
    //remove the sign
    num = Math.abs(num);
    //if the number is in scientific notation remove it
    if (/\d+\.?\d*e[\+\-]*\d+/i.test(num)) {
      var zero = "0",
        parts = String(num).toLowerCase().split("e"), //split into coeff and exponent
        e = parts.pop(), //store the exponential part
        l = Math.abs(e), //get the number of zeros
        sign = e / l,
        coeff_array = parts[0].split(".");
      if (sign === -1) {
        l = l - coeff_array[0].length;
        if (l < 0) {
          num =
            coeff_array[0].slice(0, l) +
            "." +
            coeff_array[0].slice(l) +
            (coeff_array.length === 2 ? coeff_array[1] : "");
        } else {
          num = zero + "." + new Array(l + 1).join(zero) + coeff_array.join("");
        }
      } else {
        var dec = coeff_array[1];
        if (dec) l = l - dec.length;
        if (l < 0) {
          num = coeff_array[0] + dec.slice(0, l) + "." + dec.slice(l);
        } else {
          num = coeff_array.join("") + new Array(l + 1).join(zero);
        }
      }
    }

    return nsign < 0 ? "-" + num : num;
  }

  useEffect(() => {
    const fixedRate = toFixed(rateVal);
    setMaxLimitCheck(false);
    if (parseInt(fixedRate) > 1000000) {
      setMaxLimitCheck(true);
    }
  }, [rateVal]);

  return (
    <>
      <Col
        className={
          windowDimensions.width > 769 ? "form-parent" : "mobile-form-parnet"
        }
        xs={24}
        lg={24}
        style={{ height: "60vh" }}
      >
        <Col className="from-div">
          {windowDimensions.width > 768 && (
            <div className="BudgetFormHeading">Add desired pay</div>
          )}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Row className="HourlyBid">
              {/* <Button
                className={`btn-WK-`}
                onClick={() => { }}
              >
                Hourly
              </Button> */}
              {/* <select
                onChange={(e) => setDesiredSalary(e.target.value)}
                className="hourly-container"
              >
                <option>Hourly</option>
                <option>Yearly</option>
                <option>Weekly</option>
              </select> */}
              {desiredSalary}
            </Row>
          </div>

          {location.state.PermanentJob ? (
            <Row className="candidate-desired-containerr">
              <div
                className={`candidate-desired-pay-msg candidate-desired-pay-msg-grey`}
              >
                Hourly rates will be applicable for contract gigs
              </div>
            </Row>
          ) : (
            <Row className="candidate-desired-containerr">
              <div
                className={`candidate-desired-pay-msg candidate-desired-pay-msg-grey`}
              >
                Yearly rates will be applicable for permanent gigs
              </div>
            </Row>
          )}

          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Row className="Amount_Containerr">
              <div
                className="iconContainerr"
                onClick={() => {
                  if (rateVal <= 0) {
                    setRateVal(rateVal);
                  } else {
                    setRateVal(parseInt(rateVal) - 1);
                  }
                }}
              >
                <img src={minus} alt="minus" className="iconn" />
              </div>

              {/* <div className="amount">
                {rate}
              </div> */}
              <input
                className="input-holder"
                type="text"
                placeholder={"0"}
                defaultValue={rate}
                value={isNaN(rateVal) ? 0 : rateVal}
                onChange={(e) => handleInput(e)}
              />
              <div
                className="iconContainerr"
                onClick={() => setRateVal(parseInt(rateVal) + 1)}
              >
                <img src={plus} alt="plus" className="iconn" />
              </div>
            </Row>
          </div>

          {maxLimitcheck ? (
            <div
              style={{
                color: "red",
                alignSelf: "center",
                width: "40%",
                margin: "auto",
                textAlign: "center",
              }}
            >
              <br />
              Max limit exceeded
            </div>
          ) : null}

          <Row>
            <Divider />
          </Row>

          <div
            style={{
              display: "flex",
              justifyContent: windowDimensions.width > 768 && "flex-end",
            }}
          >
            <button className={"jobBudgetForm-back-btn"} onClick={backHandler}>
              Back
            </button>

            <button className="jobBudgetForm-next-btn" onClick={nextHandler}>
              Next
            </button>
          </div>
        </Col>
      </Col>
    </>
  );
};
export default JobBudgetForm;
